var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod';
import { useState, useCallback } from 'react';
import moment from 'moment';
var createDocumentoSchema = function (exigeValidade) {
    return z.object({
        servicoDocumentoId: z.number(),
        dataValidade: exigeValidade
            ? z
                .string()
                .min(1, 'Data de validade é obrigatória')
                .refine(function (data) { return moment(data, 'YYYY-MM-DD', true).isValid(); }, {
                message: 'Data de validade inválida.',
            })
                .refine(function (data) {
                return moment(data, 'YYYY-MM-DD', true).isSameOrAfter(moment(), 'day');
            }, {
                message: 'A data de validade não pode ser anterior a data atual.',
            })
            : z.string().optional().nullable(),
    });
};
export var useDocumentValidation = function (initialDocuments) {
    var _a = useState(initialDocuments), documentosAnexados = _a[0], setDocumentosAnexados = _a[1];
    var _b = useState({}), errors = _b[0], setErrors = _b[1];
    var validateSection = useCallback(function (secao) {
        var secaoErros = [];
        secao.documentos.forEach(function (servicoDocumento) {
            var documento = documentosAnexados.find(function (doc) { return doc.servicoDocumentoId === servicoDocumento.id; });
            if (servicoDocumento.obrigatorio && !documento) {
                secaoErros.push({
                    servicoDocumentoId: servicoDocumento.id,
                    key: 'documento',
                    message: 'Documento é obrigatório',
                });
                return;
            }
            if (documento) {
                var schema = createDocumentoSchema(servicoDocumento.exigeValidade);
                var parseResult = schema.safeParse(documento);
                if (!parseResult.success) {
                    parseResult.error.errors.forEach(function (zodError) {
                        secaoErros.push({
                            servicoDocumentoId: servicoDocumento.id,
                            key: "".concat(zodError.path),
                            message: zodError.message,
                        });
                    });
                }
            }
        });
        if (secaoErros.length > 0) {
            setErrors(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[secao.id] = secaoErros, _a)));
            });
            return false;
        }
        else {
            setErrors(function (prev) {
                var _a = prev, _b = secao.id, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                return rest;
            });
            return true;
        }
    }, [documentosAnexados]);
    var validateAllSections = useCallback(function (secoes) {
        var allValid = secoes.every(validateSection);
        return allValid;
    }, [validateSection]);
    var handleUpdateDocumento = useCallback(function (documento) {
        setDocumentosAnexados(function (prev) {
            var exists = prev.some(function (doc) { return doc.servicoDocumentoId === documento.servicoDocumentoId; });
            return exists
                ? prev.map(function (doc) {
                    return doc.servicoDocumentoId === documento.servicoDocumentoId
                        ? documento
                        : doc;
                })
                : __spreadArray(__spreadArray([], prev, true), [documento], false);
        });
    }, []);
    return {
        documentosAnexados: documentosAnexados,
        errors: errors,
        validateSection: validateSection,
        validateAllSections: validateAllSections,
        handleUpdateDocumento: handleUpdateDocumento,
    };
};
